import { gql } from '@apollo/client';

export const LOGIN = gql`
  mutation login($data: AuthInput!) {
    login(data: $data) {
      token
      refreshToken
      tenantUserData
      logoutOthers
    }
  }
`;

export const LOGOUT_USER = gql`
  mutation logout {
    logout {
      message
      status
    }
  }
`;

export const FORGOT_PASSWORD = gql`
  mutation forgotUserPassword($email: String) {
    forgotUserPassword(where: { email: $email }) {
      status
      message
    }
  }
`;
export const RESET_PASSWORD = gql`
  mutation updateUserPassword($data: TokenInput!) {
    updateUserPassword(data: $data) {
      status
      message
    }
  }
`;

export const TOKEN_VALIDATION = gql`
  mutation isValidToken($data: TokenInput!) {
    isValidToken(data: $data) {
      message
      status
    }
  }
`;

export const CHANGE_PASSWORD = gql`
  mutation changePassword($data: ChangePasswordInput!) {
    changePassword(data: $data) {
      status
      message
    }
  }
`;
